import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        autoImport: false,

        state() {
            return {
                id: null,
                description: '',
                reference_id: '',
                slide_deck_urls: null,
                slide_deck_cookies: {},
                thumbnail_signed_url: null,
                total_slides: null,
                title: '',
                slide_deck: null,
                uuid: null,
                tags: [],
                groups: [],
                statuses: [],
                course_codes: [],
                slide_deck_activities: null,
                slide_deck_activity_templates: null,
                aspect_ratio: null,
                output_extension: null,
                has_pdf: null,
                input_size: null,
                original_file_name: null,
                created_at: null,
                updated_at: null,
                archived_at: null,
            };
        },

        getters: {},

        actions: {
            edit(context, { field, value }) {
                context.commit('EDIT_FIELD', { field, value });

                context.commit(
                    'SlideDecks/AUTO_SAVE',
                    { item: context.state, field },
                    {
                        root: true,
                    }
                );
            },
        },

        mutations: {
            EDIT_FIELD(state, { field, value }) {
                state[field] = value;
            },
        },
    }
);
